module.exports = __webpack_public_path__ + "images/help/icon-twr54-c170dedb1e5f172e8717cd7063e34865.png";